import api from "./api";

export const storeWarehouseInventory = async (
    payload
) => {
    const response = await api.post(
        "/warehouseinventory/store",
        {
            warehouseShelfId: Number(
                payload.warehouseShelfId
            ),
            shipmentId:
                payload.shipmentId === "" ||
                    payload.shipmentId === null ||
                    payload.shipmentId === undefined
                    ? null
                    : Number(payload.shipmentId),
            parcelId:
                payload.parcelId === "" ||
                    payload.parcelId === null ||
                    payload.parcelId === undefined
                    ? null
                    : Number(payload.parcelId),
            weightKg: Number(payload.weightKg),
            volumeM3: Number(payload.volumeM3),
            notes:
                payload.notes?.trim() || null,
        }
    );

    return response.data;
};

export const getWarehouseInventory = async (
    includeReleased = false
) => {
    const response = await api.get(
        "/warehouseinventory",
        {
            params: {
                includeReleased,
            },
        }
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const getWarehouseInventoryById = async (
    id
) => {
    const inventoryId = Number(id);

    if (
        !Number.isInteger(inventoryId) ||
        inventoryId <= 0
    ) {
        throw new Error(
            "Warehouse inventory ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehouseinventory/${inventoryId}`
    );

    return response.data;
};

export const getInventoryByShelf = async (
    warehouseShelfId,
    includeReleased = false
) => {
    const shelfId = Number(warehouseShelfId);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehouseinventory/shelf/${shelfId}`,
        {
            params: {
                includeReleased,
            },
        }
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const getInventoryByWarehouse = async (
    warehouseId,
    includeReleased = false
) => {
    const id = Number(warehouseId);

    if (!Number.isInteger(id) || id <= 0) {
        throw new Error(
            "Warehouse ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehouseinventory/warehouse/${id}`,
        {
            params: {
                includeReleased,
            },
        }
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const releaseWarehouseInventory = async (
    id,
    notes = null
) => {
    const inventoryId = Number(id);

    if (
        !Number.isInteger(inventoryId) ||
        inventoryId <= 0
    ) {
        throw new Error(
            "Warehouse inventory ID must be a positive integer."
        );
    }

    const response = await api.patch(
        `/warehouseinventory/${inventoryId}/release`,
        {
            notes: notes?.trim() || null,
        }
    );

    return response.data;
};

export const moveWarehouseInventory = async (
    id,
    targetShelfId,
    notes = null
) => {
    const inventoryId = Number(id);
    const destinationShelfId =
        Number(targetShelfId);

    if (
        !Number.isInteger(inventoryId) ||
        inventoryId <= 0
    ) {
        throw new Error(
            "Warehouse inventory ID must be a positive integer."
        );
    }

    if (
        !Number.isInteger(destinationShelfId) ||
        destinationShelfId <= 0
    ) {
        throw new Error(
            "Target shelf ID must be a positive integer."
        );
    }

    const response = await api.patch(
        `/warehouseinventory/${inventoryId}/move`,
        {
            targetShelfId:
                destinationShelfId,
            notes: notes?.trim() || null,
        }
    );

    return response.data;
};

export const recalculateWarehouseShelf = async (
    warehouseShelfId
) => {
    const shelfId = Number(warehouseShelfId);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.post(
        `/warehouseinventory/shelf/${shelfId}/recalculate`
    );

    return response.data;
};

const warehouseInventoryService = {
    storeWarehouseInventory,
    getWarehouseInventory,
    getWarehouseInventoryById,
    getInventoryByShelf,
    getInventoryByWarehouse,
    releaseWarehouseInventory,
    moveWarehouseInventory,
    recalculateWarehouseShelf,
};

export default warehouseInventoryService;